import { render, staticRenderFns } from "./FriendManagementGroupAdminNavigation.vue?vue&type=template&id=ca322182"
import script from "./FriendManagementGroupAdminNavigation.vue?vue&type=script&lang=ts"
export * from "./FriendManagementGroupAdminNavigation.vue?vue&type=script&lang=ts"
import style0 from "./FriendManagementGroupAdminNavigation.vue?vue&type=style&index=0&id=ca322182&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports